// Sharp icon definitions extracted from @awesome.me/kit-f0c5f181fe
//
// WHY INLINED: The Kit package (@awesome.me/kit-*) lives on FontAwesome's private npm
// registry (npm.fontawesome.com) which requires an auth token. Our VCS and API Dockerfiles
// copy all workspace package.json files to resolve the monorepo dependency graph, so adding
// a private-registry dependency to ANY package breaks Docker builds for ALL services. Inlining
// the ~15KB of SVG path data avoids coupling every Dockerfile to FA's private registry.
//
// LONG-TERM FIX: Add `COPY bunfig.toml ./` to the VCS and API Dockerfiles (using Docker
// BuildKit secrets so the FA token isn't baked into image layers), then import directly
// from @awesome.me/kit-f0c5f181fe and delete this file.
//
// TO ADD A NEW ICON: run `bun -e "console.log(JSON.stringify(require('@awesome.me/kit-f0c5f181fe/icons/sharp/regular').faIconName))"`,
// then paste the definition below.

export const sharpRegular = {
  faAngleDown: {
    prefix: 'fasr',
    iconName: 'angle-down',
    icon: [
      384,
      512,
      [8964],
      'f107',
      'M192.4 385.9l17-17 160-160 17-17-33.9-33.9-17 17-143 143-143-143-17-17-33.9 33.9 17 17 160 160 17 17z',
    ],
  },
  faAngleLeft: {
    prefix: 'fasr',
    iconName: 'angle-left',
    icon: [
      256,
      512,
      [8249],
      'f104',
      'M-1.5 256l17-17 160-160 17-17 33.9 33.9-17 17-143 143 143 143 17 17-33.9 33.9-17-17-160-160-17-17z',
    ],
  },
  faAngleRight: {
    prefix: 'fasr',
    iconName: 'angle-right',
    icon: [
      256,
      512,
      [8250],
      'f105',
      'M258.4 256l-17 17-160 160-17 17-33.9-33.9 17-17 143-143-143-143-17-17 33.9-33.9 17 17 160 160 17 17z',
    ],
  },
  faAnglesLeft: {
    prefix: 'fasr',
    iconName: 'angles-left',
    icon: [
      448,
      512,
      [171, 'angle-double-left'],
      'f100',
      'M15.5 239l-17 17 17 17 160 160 17 17 33.9-33.9-17-17-143-143 143-143 17-17-33.9-33.9-17 17-160 160zm192 0l-17 17 17 17 160 160 17 17 33.9-33.9-17-17-143-143 143-143 17-17-33.9-33.9-17 17-160 160z',
    ],
  },
  faAnglesRight: {
    prefix: 'fasr',
    iconName: 'angles-right',
    icon: [
      448,
      512,
      [187, 'angle-double-right'],
      'f101',
      'M241.4 273l17-17-17-17-160-160-17-17-33.9 33.9 17 17 143 143-143 143-17 17 33.9 33.9 17-17 160-160zm192 0l17-17-17-17-160-160-17-17-33.9 33.9 17 17 143 143-143 143-17 17 33.9 33.9 17-17 160-160z',
    ],
  },
  faArrowDown: {
    prefix: 'fasr',
    iconName: 'arrow-down',
    icon: [
      448,
      512,
      [8595],
      'f063',
      'M207.5 505l17 17 17-17 168-168 17-17-33.9-33.9-17 17-127 127 0-430.1-48 0 0 430.1-127-127-17-17-33.9 33.9 17 17 168 168z',
    ],
  },
  faArrowRight: {
    prefix: 'fasr',
    iconName: 'arrow-right',
    icon: [
      576,
      512,
      [8594],
      'f061',
      'M537.4 273l17-17-17-17-168-168-17-17-33.9 33.9 17 17 127 127-430.1 0 0 48 430.1 0-127 127-17 17 33.9 33.9 17-17 168-168z',
    ],
  },
  faArrowRotateRight: {
    prefix: 'fasr',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635, 'arrow-right-rotate', 'arrow-rotate-forward', 'redo'],
      'f01e',
      'M464.2 0l0 102.1-27.1-27.1c-100-100-262.1-100-362 0-50 50-75 115.5-75 181 0 141.4 114.6 256 256 256 102.4 0 190.7-60.1 231.6-146.8l-43.4-20.5c-33.3 70.6-105.1 119.3-188.2 119.3-114.9 0-208-93.1-208-208 0-53.3 20.3-106.5 60.9-147.1 81.2-81.2 212.9-81.2 294.2 0l27.1 27.1-102.2 0 0 48 184.1 0 0-184-48 0z',
    ],
  },
  faArrowUp: {
    prefix: 'fasr',
    iconName: 'arrow-up',
    icon: [
      448,
      512,
      [8593],
      'f062',
      'M241.4 15l-17-17-17 17-185 185 33.9 33.9 17-17 127-127 0 430.1 48 0 0-430.1 127 127 17 17 33.9-33.9-17-17-168-168z',
    ],
  },
  faBook: {
    prefix: 'fasr',
    iconName: 'book',
    icon: [
      448,
      512,
      [128212],
      'f02d',
      'M24 0L0 0 0 432 .4 432c-.2 2.6-.4 5.3-.4 8l0 72 448 0 0-48-32 0 0-64 32 0 0-400-424 0zM368 400l0 64-320 0 0-24c0-22.1 17.9-40 40-40l280 0zM88 352c-14.4 0-28 3.5-40 9.6l0-313.6 352 0 0 304-312 0zm40-224l0 48 224 0 0-48-224 0zm224 96l-224 0 0 48 224 0 0-48z',
    ],
  },
  faBookBookmark: {
    prefix: 'fasr',
    iconName: 'book-bookmark',
    icon: [
      448,
      512,
      [],
      'e0bb',
      'M0 0l448 0 0 400-32 0 0 64 32 0 0 48-448 0 0-72c0-2.7 .1-5.4 .4-8L0 432 0 0zM88 400c-22.1 0-40 17.9-40 40l0 24 320 0 0-64-280 0zM48 361.6c12-6.1 25.6-9.6 40-9.6l312 0 0-304-48 0 0 176-80-48-80 48 0-176-144 0 0 313.6z',
    ],
  },
  faBookOpen: {
    prefix: 'fasr',
    iconName: 'book-open',
    icon: [
      512,
      512,
      [128214, 128366],
      'f518',
      'M232 114l0 344.4C184.4 441 134 432 83.2 432L48 432 48 80 83.2 80c44.4 0 88.3 8.8 129.2 25.8L232 114zm48 344.4l0-344.4 19.6-8.2C340.5 88.8 384.4 80 428.8 80l35.2 0 0 352-35.2 0c-50.8 0-101.2 9-148.8 26.4zM512 32l-83.2 0c-50.7 0-100.9 10-147.7 29.5L256 72 230.9 61.5C184.1 42 133.9 32 83.2 32L0 32 0 480 83.2 480c50.7 0 100.9 10 147.7 29.5L256 520 281.1 509.5c46.8-19.5 97-29.5 147.7-29.5l83.2 0 0-448z',
    ],
  },
  faBuilding: {
    prefix: 'fasr',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687, 127970],
      'f1ad',
      'M48 48l0 416 96 0 0-112 96 0 0 112 96 0 0-416-288 0zM0 0L384 0 384 512 0 512 0 0zM96 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM96 224l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0z',
    ],
  },
  faCheck: {
    prefix: 'fasr',
    iconName: 'check',
    icon: [
      512,
      512,
      [10003, 10004],
      'f00c',
      'M489.9 82.5l-14 19.5-264 368-16.5 23-20-20-136-136-17-17 33.9-33.9 17 17 116 116 247.5-345 14-19.5 39 28z',
    ],
  },
  faChevronDown: {
    prefix: 'fasr',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      'M256.4 425.9l17-17 200-200 17-17-33.9-33.9-17 17-183 183-183-183-17-17-33.9 33.9 17 17 200 200 17 17z',
    ],
  },
  faChevronRight: {
    prefix: 'fasr',
    iconName: 'chevron-right',
    icon: [
      384,
      512,
      [9002],
      'f054',
      'M362.4 256l-17 17-200 200-17 17-33.9-33.9 17-17 183-183-183-183-17-17 33.9-33.9 17 17 200 200 17 17z',
    ],
  },
  faChevronUp: {
    prefix: 'fasr',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      'M256.4 86.1l17 17 200 200 17 17-33.9 33.9-17-17-183-183-183 183-17 17-33.9-33.9 17-17 200-200 17-17z',
    ],
  },
  faCircle: {
    prefix: 'fasr',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679, 9898, 9899, 11044, 61708, 61915, 128308, 128309, 128992, 128993, 128994, 128995, 128996],
      'f111',
      'M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z',
    ],
  },
  faCircleCheck: {
    prefix: 'fasr',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533, 'check-circle'],
      'f058',
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM379.7 178.8l-14.1 19.4-122.1 167.9-16.5 22.7-92.7-92.7 33.9-33.9 53 53 105.6-145.2 14.1-19.4 38.8 28.2z',
    ],
  },
  faCircleExclamation: {
    prefix: 'fasr',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ['exclamation-circle'],
      'f06a',
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm28 332l-56 0 0-56 56 0 0 56zm-8.8-92l-38.4 0-12.8-160 64 0-12.8 160z',
    ],
  },
  faCircleHalfStroke: {
    prefix: 'fasr',
    iconName: 'circle-half-stroke',
    icon: [
      512,
      512,
      [9680, 'adjust'],
      'f042',
      'M280 462.6l0-413.3C383.6 61.3 464 149.2 464 256S383.6 450.7 280 462.6zm-48 0C128.4 450.7 48 362.8 48 256S128.4 61.3 232 49.4l0 413.3zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z',
    ],
  },
  faCirclePlus: {
    prefix: 'fasr',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      ['plus-circle'],
      'f055',
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM232 368l48 0 0-88 88 0 0-48-88 0 0-88-48 0 0 88-88 0 0 48 88 0 0 88z',
    ],
  },
  faCircleXmark: {
    prefix: 'fasr',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532, 'times-circle', 'xmark-circle'],
      'f057',
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM172.1 305.9l-17 17 33.9 33.9c5.8-5.8 28.1-28.1 66.9-66.9 38.8 38.8 61.1 61.1 66.9 66.9l33.9-33.9c-5.8-5.8-28.1-28.1-66.9-66.9 38.8-38.8 61.1-61.1 66.9-66.9l-33.9-33.9c-5.8 5.8-28.1 28.1-66.9 66.9l-66.9-66.9-33.9 33.9c5.8 5.8 28.1 28.1 66.9 66.9l-49.9 49.9z',
    ],
  },
  faClock: {
    prefix: 'fasr',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339, 'clock-four'],
      'f017',
      'M464 256a208 208 0 1 1 -416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM232 120l0 148.8 10.7 7.1 96 64 20 13.3 26.6-39.9c-2.4-1.6-37.5-25-105.3-70.2l0-147.2-48 0 0 24z',
    ],
  },
  faClockRotateLeft: {
    prefix: 'fasr',
    iconName: 'clock-rotate-left',
    icon: [
      512,
      512,
      ['history'],
      'f1da',
      'M48 106.7l0-74.7-48 0 0 160 160 0 0-48-79.3 0c37-57.8 101.7-96 175.3-96 114.9 0 208 93.1 208 208S370.9 464 256 464c-42.5 0-81.9-12.7-114.7-34.5l-20-13.3-26.5 40 20 13.3c40.5 26.8 89.1 42.5 141.3 42.5 141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM280 128l-48 0 0 137.9 7 7c57.2 57.2 86.8 86.8 89 89L361.9 328c-3.3-3.3-30.6-30.6-81.9-81.9L280 128z',
    ],
  },
  faCode: {
    prefix: 'fasr',
    iconName: 'code',
    icon: [
      640,
      512,
      [],
      'f121',
      'M369.5 16.9l7.1-22.9 45.8 14.2-7.1 22.9-144 464-7.1 22.9-45.8-14.2 7.1-22.9 144-464zM194.4 152l-17 17-87 87 87 87 17 17-33.9 33.9-17-17-104-104-17-17 17-17 104-104 17-17 33.9 33.9zm252.1 0l33.9-33.9 17 17 104 104 17 17-17 17-104 104-17 17-33.9-33.9 17-17 87-87-87-87-17-17z',
    ],
  },
  faCodeBranch: {
    prefix: 'fasr',
    iconName: 'code-branch',
    icon: [
      448,
      512,
      [],
      'f126',
      'M48 48l0 64 64 0 0-64-64 0zM0 0l160 0 0 160-56 0 0 72 184 0c30.9 0 56-25.1 56-56l0-16-56 0 0-160 160 0 0 160-56 0 0 16c0 57.4-46.6 104-104 104l-184 0 0 72 56 0 0 160-160 0 0-160 56 0 0-192-56 0 0-160zM112 464l0-64-64 0 0 64 64 0zM400 48l-64 0 0 64 64 0 0-64z',
    ],
  },
  faCodeCompare: {
    prefix: 'fasr',
    iconName: 'code-compare',
    icon: [
      512,
      512,
      [],
      'e13a',
      'M174.1 24l32 32-46.1 0c-48.6 0-88 39.4-88 88l0 208-56 0 0 160 160 0 0-160-56 0 0-208c0-22.1 17.9-40 40-40l46.1 0c-9.7 9.7-20.4 20.4-32 32L208 169.9c4.8-4.8 29.1-29.1 73-73l17-17c-4.8-4.8-29.1-29.1-73-73L208-9.9 174.1 24zM448 48l0 64-64 0 0-64 64 0zM496 0l-160 0 0 160 56 0 0 208c0 22.1-17.9 40-40 40l-46.1 0 32-32-33.9-33.9c-4.8 4.8-29.1 29.1-73 73l-17 17c4.8 4.8 29.1 29.1 73 73l17 17 33.9-33.9c-11.6-11.6-22.3-22.3-32-32l46.1 0c48.6 0 88-39.4 88-88l0-208 56 0 0-160zM128 400l0 64-64 0 0-64 64 0z',
    ],
  },
  faCopy: {
    prefix: 'fasr',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      'M400 336l-224 0 0-288 156.1 0 67.9 67.9 0 220.1zM448 96l-96-96-224 0 0 384 320 0 0-288zM48 128l-48 0 0 384 320 0 0-80-48 0 0 32-224 0 0-288 32 0 0-48-32 0z',
    ],
  },
  faDownload: {
    prefix: 'fasr',
    iconName: 'download',
    icon: [
      448,
      512,
      [],
      'f019',
      'M248 24l0-24-48 0 0 270.1c-49.7-49.7-76.4-76.4-80-80l-33.9 33.9 17 17 104 104 17 17 17-17 104-104 17-17-33.9-33.9c-3.6 3.6-30.3 30.3-80 80L248 24zM66.2 272l-66.2 0 0 208 448 0 0-208-66.2 0-48 48 66.2 0 0 112-352 0 0-112 66.2 0-48-48zM368 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z',
    ],
  },
  faEllipsis: {
    prefix: 'fasr',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ['ellipsis-h'],
      'f141',
      'M0 304l0-96 96 0 0 96-96 0zm176 0l0-96 96 0 0 96-96 0zm176-96l96 0 0 96-96 0 0-96z',
    ],
  },
  faFile: {
    prefix: 'fasr',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462, 128196, 128459],
      'f15b',
      'M176 48l-128 0 0 416 288 0 0-256-160 0 0-160zM316.1 160l-92.1-92.1 0 92.1 92.1 0zM48 0L224 0 384 160 384 512 0 512 0 0 48 0z',
    ],
  },
  faFileCode: {
    prefix: 'fasr',
    iconName: 'file-code',
    icon: [
      384,
      512,
      [],
      'f1c9',
      'M48 48l128 0 0 160 160 0 0 256-288 0 0-416zM224 67.9l92.1 92.1-92.1 0 0-92.1zM224 0L0 0 0 512 384 512 384 160 224 0zM132.8 257.6c-38.2 50.9-57.8 77.1-58.8 78.4 1 1.3 20.6 27.5 58.8 78.4l38.4-28.8-37.2-49.6 37.2-49.6-38.4-28.8zm80 28.8l37.2 49.6-37.2 49.6 38.4 28.8c38.2-50.9 57.8-77.1 58.8-78.4-1-1.3-20.6-27.5-58.8-78.4l-38.4 28.8z',
    ],
  },
  faFileLines: {
    prefix: 'fasr',
    iconName: 'file-lines',
    icon: [
      384,
      512,
      [61686, 128441, 128462, 'file-alt', 'file-text'],
      'f15c',
      'M48 48l128 0 0 160 160 0 0 256-288 0 0-416zM224 67.9l92.1 92.1-92.1 0 0-92.1zM224 0L0 0 0 512 384 512 384 160 224 0zM120 256l-24 0 0 48 192 0 0-48-168 0zm0 96l-24 0 0 48 192 0 0-48-168 0z',
    ],
  },
  faFolder: {
    prefix: 'fasr',
    iconName: 'folder',
    icon: [
      512,
      512,
      [61716, 128193, 128447, 'folder-blank'],
      'f07b',
      'M288 80l-64-48-224 0 0 416 512 0 0-368-224 0zm176 48l0 272-416 0 0-320 160 0c40.5 30.4 61.9 46.4 64 48l192 0z',
    ],
  },
  faFolderOpen: {
    prefix: 'fasr',
    iconName: 'folder-open',
    icon: [
      576,
      512,
      [61717, 128194, 128449],
      'f07c',
      'M256 32l64 48 192 0 0 80-48 0 0-32-160 0c-2.1-1.6-23.5-17.6-64-48L80 80 80 299.8 109.7 208 576 208c-2.6 8-28.5 88-77.7 240L32 448 32 32 256 32zm32 368l175.4 0 46.6-144-365.4 0-46.6 144 190 0z',
    ],
  },
  faGear: {
    prefix: 'fasr',
    iconName: 'gear',
    icon: [
      576,
      512,
      [9881, 'cog'],
      'f013',
      'M232.2-16L213-16c-1 4.2-7.5 33.2-19.6 86.8-6.3 3.2-12.3 6.7-18.2 10.5l-85-26.4-9.6 16.6-56 97-9.6 16.6c3.2 2.9 25 23.1 65.4 60.4-.3 6.9-.3 14 0 21-40.4 37.3-62.2 57.5-65.4 60.4l9.6 16.6 56 97 9.6 16.6c4.2-1.3 32.5-10.1 85-26.4 5.9 3.8 11.9 7.3 18.2 10.5 12.1 53.6 18.6 82.6 19.6 86.8l150.4 0c1-4.2 7.5-33.2 19.6-86.8 6.2-3.2 12.3-6.7 18.2-10.5 52.5 16.3 80.8 25.1 85 26.4l9.6-16.6 56-97 9.6-16.6c-3.2-2.9-25-23.1-65.4-60.4 .3-6.9 .3-14 0-21 40.4-37.3 62.2-57.5 65.4-60.4l-9.6-16.6-56-97-9.6-16.6c-4.2 1.3-32.5 10.1-85 26.4-5.9-3.8-11.9-7.3-18.2-10.5-12.1-53.6-18.6-82.6-19.6-86.8L232.2-16zm5.5 108.7l13.7-60.7 73.6 0 13.7 60.7 2.7 11.8 11.1 4.9c10.8 4.8 21 10.7 30.4 17.6l9.8 7.2 11.6-3.6 59.5-18.5 36.8 63.8-45.8 42.3-8.9 8.2 1.3 12c.6 5.8 1 11.6 1 17.6s-.3 11.8-1 17.6l-1.3 12 8.9 8.2 45.8 42.3-36.8 63.8-59.5-18.5-11.6-3.6-9.8 7.2c-9.4 6.9-19.6 12.9-30.4 17.6l-11.1 4.9-2.7 11.8-13.7 60.7-73.6 0-13.7-60.7-2.7-11.8-11.1-4.9c-10.8-4.8-21-10.7-30.4-17.6l-9.8-7.2-11.6 3.6-59.5 18.5-36.8-63.8 45.8-42.3 8.9-8.2-1.3-12c-.6-5.8-1-11.6-1-17.6s.3-11.8 1-17.6l1.3-12-8.9-8.2-45.8-42.3 36.8-63.8 59.5 18.5 11.6 3.6 9.8-7.2c9.4-6.9 19.6-12.9 30.4-17.6l11.1-4.9 2.7-11.8zM335.8 256a47.8 47.8 0 1 1 -95.7 0 47.8 47.8 0 1 1 95.7 0zm-47.7-96a96 96 0 1 0 -.3 192 96 96 0 1 0 .3-192z',
    ],
  },
  faInbox: {
    prefix: 'fasr',
    iconName: 'inbox',
    icon: [
      512,
      512,
      [],
      'f01c',
      'M48 336l0 96 416 0 0-96-83.2 0c-19.5 29.3-30.2 45.3-32 48l-185.7 0c-1.8-2.7-12.5-18.7-32-48L48 336zm415.6-48l-26-208-363.3 0-26 208 108.5 0c1.8 2.7 12.5 18.7 32 48l134.3 0c19.5-29.3 30.2-45.3 32-48l108.5 0zM0 288l32-256 448 0 32 256 0 192-512 0 0-192z',
    ],
  },
  faKey: {
    prefix: 'fasr',
    iconName: 'key',
    icon: [
      512,
      512,
      [128273],
      'f084',
      'M315.7 302.4l-24.2-3.8c-11.1 11.1-23.6 23.6-37.4 37.4l-78.1 0 0 64-64 0 0 64-64 0 0-78.1 148.1-148.1 17.3-17.3-3.8-24.2c-1-6.6-1.6-13.4-1.6-20.3 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128c-6.9 0-13.7-.6-20.3-1.6zM272 384l1.9 0c1.3-1.3 12.7-12.7 34.2-34.2 9.1 1.4 18.4 2.2 27.9 2.2 97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 9.5 .7 18.8 2.2 27.9l-155.2 155.2-7 7 0 145.9 160 0 0-64 64 0 0-64 48 0zm96-208a32 32 0 1 0 0-64 32 32 0 1 0 0 64z',
    ],
  },
  faLink: {
    prefix: 'fasr',
    iconName: 'link',
    icon: [
      576,
      512,
      [128279, 'chain'],
      'f0c1',
      'M427.5 88c-21.4 0-42.2 6.9-59.3 19.4-11.4-11.7-24.4-22.1-38.4-30.7 27-23.6 61.7-36.7 97.7-36.7 82 0 148.5 66.5 148.5 148.5 0 39.4-15.6 77.1-43.5 105l-79.1 79.1c-27.8 27.8-65.6 43.5-105 43.5-82 0-148.5-66.5-148.5-148.5 0-27.6 7.7-54.5 21.9-77.6L262.8 215c-9.6 15.7-14.8 33.8-14.8 52.5 0 55.5 45 100.5 100.5 100.5 26.6 0 52.2-10.6 71-29.4l79.1-79.1C517.4 240.6 528 215.1 528 188.5 528 133 483 88 427.5 88zm-200 56c-26.6 0-52.2 10.6-71 29.4L77.4 252.5c-18.8 18.8-29.4 44.4-29.4 71 0 55.5 45 100.5 100.5 100.5 21.4 0 42.2-6.9 59.3-19.4 11.4 11.8 24.4 22.1 38.4 30.7-27 23.6-61.7 36.7-97.7 36.7-82 0-148.5-66.5-148.5-148.5 0-39.4 15.6-77.1 43.5-105l79.1-79.1c27.8-27.8 65.6-43.5 105-43.5 82 0 148.5 66.5 148.5 148.5 0 27.6-7.7 54.5-21.9 77.6L313.2 297c9.6-15.7 14.8-33.8 14.8-52.5 0-55.5-45-100.5-100.5-100.5z',
    ],
  },
  faMinus: {
    prefix: 'fasr',
    iconName: 'minus',
    icon: [448, 512, [8211, 8722, 10134, 'subtract'], 'f068', 'M0 232l448 0 0 48-448 0 0-48z'],
  },
  faMoon: {
    prefix: 'fasr',
    iconName: 'moon',
    icon: [
      512,
      512,
      [9214, 127769],
      'f186',
      'M359.7 21.9C336 11.3 310.4 4.3 283.5 1.5 274.5 .5 265.3 0 256 0 114.6 0 0 114.6 0 256S114.6 512 256 512c55.7 0 107.3-17.8 149.3-48 .9-.7 1.8-1.3 2.7-2 20.3-15 38.3-33 53.4-53.2-17 4.7-34.9 7.2-53.4 7.2-6.1 0-12.1-.3-18.1-.8-102-9.2-181.9-94.8-181.9-199.2 0-68.2 34.1-128.4 86.2-164.5 19.6-13.6 41.7-23.7 65.5-29.6zM223.2 50.6c-39.3 43.9-63.2 101.8-63.2 165.4 0 109.2 70.6 201.9 168.6 235-22.6 8.4-47 13-72.6 13-114.9 0-208-93.1-208-208 0-103.7 75.9-189.7 175.2-205.4z',
    ],
  },
  faPen: {
    prefix: 'fasr',
    iconName: 'pen',
    icon: [
      576,
      512,
      [128394],
      'f304',
      'M16 528c5.8-20.7 24.5-87.4 56-200L382.1 17.9 416-16C431.6-.4 468.3 36.3 526.1 94.1L560 128 526.1 161.9 216 472C103.4 503.5 36.8 522.2 16 528zm174.9-98.8L397.1 223 321 146.9 114.8 353 85.2 458.8 190.9 429.2zM431 189.1L492.1 128 416 51.9 354.9 113 431 189.1z',
    ],
  },
  faPlus: {
    prefix: 'fasr',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133, 61543, 'add'],
      '2b',
      'M248 56l0-24-48 0 0 200-200 0 0 48 200 0 0 200 48 0 0-200 200 0 0-48-200 0 0-176z',
    ],
  },
  faRightFromBracket: {
    prefix: 'fasr',
    iconName: 'right-from-bracket',
    icon: [
      576,
      512,
      ['sign-out-alt'],
      'f2f5',
      'M392.9 409.4l7.5-7.1 120-113.3c10.7-10.1 22.3-21.1 35-33-11.1-10.5-59.8-56.5-155-146.3l-7.5-7.1-40.5-38.2 0 111.7-160 0 0 160 160 0 0 111.7 40.5-38.2zM485.5 256l-85 80.3 0-48.3-160 0 0-64 160 0 0-48.3 85 80.3zM200.5 80l24 0 0-48-192 0 0 448 192 0 0-48-144 0 0-352 120 0z',
    ],
  },
  faSearch: {
    prefix: 'fasr',
    iconName: 'magnifying-glass',
    icon: [
      576,
      512,
      [128269, 'search'],
      'f002',
      'M400.4 208a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zM369.6 371.1c-35.5 28.1-80.3 44.9-129.1 44.9-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1l133.9 133.9 17 17-33.9 33.9-17-17-133.9-133.9z',
    ],
  },
  faSidebar: {
    prefix: 'fasr',
    iconName: 'sidebar',
    icon: [
      512,
      512,
      [],
      'e24e',
      'M0 64l512 0 0 384-512 0 0-384zM176 352l0-48-128 0 0 48 128 0zm0-88l0-48-128 0 0 48 128 0zm0-88l0-48-128 0 0 48 128 0zm48 224l240 0 0-288-240 0 0 288z',
    ],
  },
  faSliders: {
    prefix: 'fasr',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ['sliders-h'],
      'f1de',
      'M24 72l-24 0 0 48 112 0 0 56 160 0 0 56-272 0 0 48 272 0 0 56 160 0 0-56 80 0 0-48-80 0 0-56-160 0 0-56 240 0 0-48-240 0 0-56-160 0 0 56-88 0zM320 280l0-56 64 0 0 64-64 0 0-8zM160 120l0-56 64 0 0 64-64 0 0-8zM24 392l-24 0 0 48 80 0 0 56 160 0 0-56 272 0 0-48-272 0 0-56-160 0 0 56-56 0zm104 48l0-56 64 0 0 64-64 0 0-8z',
    ],
  },
  faSort: {
    prefix: 'fasr',
    iconName: 'sort',
    icon: [
      448,
      512,
      ['unsorted'],
      'f0dc',
      'M8 224l432 0c-14.2-15.2-75.2-80.8-183.2-196.8L224-8c-4.2 4.6-61.3 65.9-171.3 184L8 224zM224 62.4L329.7 176 118.3 176 224 62.4zM8 288c14.2 15.2 75.2 80.8 183.2 196.8L224 520c4.2-4.6 61.4-65.9 171.3-184L440 288 8 288zM224 449.6L118.3 336 329.7 336 224 449.6z',
    ],
  },
  faSpinner: {
    prefix: 'fasr',
    iconName: 'spinner',
    icon: [
      512,
      512,
      [],
      'f110',
      'M288 0l0 64-64 0 0-64 64 0zm81.1 414.4l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zM224 448l64 0 0 64-64 0 0-64zM52.4 97.6l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zM64 224l0 64-64 0 0-64 64 0zM52.4 414.4l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zM512 224l0 64-64 0 0-64 64 0z',
    ],
  },
  faSunBright: {
    prefix: 'fasr',
    iconName: 'sun-bright',
    icon: [
      512,
      512,
      ['sun-alt'],
      'e28f',
      'M232 488l0-80 48 0 0 104-48 0 0-24zm0-408l0-80 48 0 0 104-48 0 0-24zM92 58c7.5 7.5 26.4 26.4 56.6 56.6l17 17-33.9 33.9C124 158 105.1 139.1 75 108.9L58 92 92 58zM380.5 346.5l73.5 73.5-33.9 33.9-73.5-73.5 33.9-33.9zM0 232l104 0 0 48-104 0 0-48zm408 0l104 0 0 48-104 0 0-48zM58 420c7.5-7.5 26.4-26.4 56.6-56.6l17-17 33.9 33.9c-7.5 7.5-26.4 26.4-56.6 56.6L92 454 58 420zM346.5 131.5c7.5-7.5 26.4-26.4 56.6-56.6L420 58 454 91.9c-7.5 7.5-26.4 26.4-56.6 56.6l-17 17-33.9-33.9zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z',
    ],
  },
  faTrash: {
    prefix: 'fasr',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      'M144-16l160 0 24 64 120 0 0 48-448 0 0-48 120 0 24-64zM56 512l-27.3-368 48.1 0 23.7 320 246.8 0 23.7-320 48.1 0-27.3 368-336 0z',
    ],
  },
  faTriangleExclamation: {
    prefix: 'fasr',
    iconName: 'triangle-exclamation',
    icon: [
      576,
      512,
      [9888, 'exclamation-triangle', 'warning'],
      'f071',
      'M315.4 33.9L533.7 432 560 480 16 480 42.3 432 260.6 33.9 288-16 315.4 33.9zM97.1 432L478.9 432 288 83.8 97.1 432zM316 396l-56 0 0-56 56 0 0 56zm-8.8-84l-38.4 0-12.8-120 64 0-12.8 120z',
    ],
  },
  faUsers: {
    prefix: 'fasr',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      'M384 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm252.8 76c5.9 2.6 12.4 4 19.2 4 26.5 0 48-21.5 48-48s-21.5-48-48-48l-.8 0c-1.6-16.6-5.8-32.4-12.1-47.1 4.2-.6 8.6-.9 12.9-.9 53 0 96 43 96 96s-43 96-96 96c-17.7 0-34.3-4.8-48.6-13.2 11.7-11.3 21.6-24.4 29.4-38.8zM208.6 242.8c-14.2 8.4-30.8 13.2-48.6 13.2-53 0-96-43-96-96s43-96 96-96c4.4 0 8.7 .3 12.9 .9-6.3 14.7-10.5 30.6-12.1 47.1l-.8 0c-26.5 0-48 21.5-48 48s21.5 48 48 48c6.8 0 13.3-1.4 19.2-4 7.8 14.4 17.7 27.5 29.4 38.8zM432 288l69.8 192-51.1 0-52.4-144-156.8 0-52.4 144-51.1 0 69.8-192 224 0zM151.2 304l-17.3 48-36.3 0-46.5 128-51.1 0 64-176 87.2 0zm354.8 48l-17.3-48 87.2 0 64 176-51.1 0-46.5-128-36.3 0z',
    ],
  },
  faXmark: {
    prefix: 'fasr',
    iconName: 'xmark',
    icon: [
      448,
      512,
      [215, 10005, 10006, 10060, 128473, 'close', 'multiply', 'remove', 'times'],
      'f00d',
      'M39.5 105l-17-17 33.9-33.9 17 17 151 151 151-151 17-17 33.9 33.9-17 17-151 151 151 151 17 17-33.9 33.9-17-17-151-151-151 151-17 17-33.9-33.9 17-17 151-151-151-151z',
    ],
  },
};

export const sharpSolid = {
  faArrowRotateRight: {
    prefix: 'fass',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635, 'arrow-right-rotate', 'arrow-rotate-forward', 'redo'],
      'f01e',
      'M463.5 224l8.5 0 0-8.5L472 0 424 0l0 78.1C381 32 327.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c104.2 0 193.5-62.1 233.7-151.4l-44.5-19.5C413 414.6 340 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c59.3 0 105.2 26.4 144.1 65.9L312 112l0 48 80 0 71.5 0 0 64z',
    ],
  },
  faBuilding: {
    prefix: 'fass',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687, 127970],
      'f1ad',
      'M384 0L0 0 0 512 384 512 384 0zM240 352l0 112-96 0 0-112 96 0zM96 96l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM96 224l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0z',
    ],
  },
  faCheck: {
    prefix: 'fass',
    iconName: 'check',
    icon: [
      512,
      512,
      [10003, 10004],
      'f00c',
      'M493 88.9l-18.8 25.9-256 352-22 30.3c-.7-.7-52.2-52.2-154.5-154.5L19 320 64.3 274.7c1.9 1.9 43.3 43.3 124.1 124.1l234-321.7 18.8-25.9 51.8 37.6z',
    ],
  },
  faCircle: {
    prefix: 'fass',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679, 9898, 9899, 11044, 61708, 61915, 128308, 128309, 128992, 128993, 128994, 128995, 128996],
      'f111',
      'M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z',
    ],
  },
  faCircleCheck: {
    prefix: 'fass',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533, 'check-circle'],
      'f058',
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm84.5-361l-119.4 164.2-69.1-69.1-33.9 33.9 88.9 88.9 19.8 19.9 16.5-22.7 135.9-186.9 14.1-19.4-38.8-28.3-14.1 19.4z',
    ],
  },
  faCircleExclamation: {
    prefix: 'fass',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ['exclamation-circle'],
      'f06a',
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM228 324l0 56 56 0 0-56-56 0zm-4-196l12.8 160 38.4 0 12.8-160-64 0z',
    ],
  },
  faCircleXmark: {
    prefix: 'fass',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532, 'times-circle', 'xmark-circle'],
      'f057',
      'M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM172.1 305.9L222.1 256c-38.8-38.8-61.1-61.1-66.9-66.9l33.9-33.9 66.9 66.9c38.8-38.8 61.1-61.1 66.9-66.9l33.9 33.9c-5.8 5.8-28.1 28.1-66.9 66.9 38.8 38.8 61.1 61.1 66.9 66.9l-33.9 33.9c-5.8-5.8-28.1-28.1-66.9-66.9-38.8 38.8-61.1 61.1-66.9 66.9l-33.9-33.9 17-17z',
    ],
  },
  faMinus: {
    prefix: 'fass',
    iconName: 'minus',
    icon: [448, 512, [8211, 8722, 10134, 'subtract'], 'f068', 'M0 224l448 0 0 64-448 0 0-64z'],
  },
  faSpinner: {
    prefix: 'fass',
    iconName: 'spinner',
    icon: [
      512,
      512,
      [],
      'f110',
      'M208 0l0 96 96 0 0-96-96 0zM0 208l0 96 96 0 0-96-96 0zM208 512l96 0 0-96-96 0 0 96zM512 208l-96 0 0 96 96 0 0-96zM41 403.1l67.9 67.9 67.9-67.9-67.9-67.9-67.9 67.9zm362 67.9l67.9-67.9-67.9-67.9-67.9 67.9 67.9 67.9zM41 108.9l67.9 67.9 67.9-67.9-67.9-67.9-67.9 67.9z',
    ],
  },
};
